export class PKBillReaderResultErrorMessage {
	public static InternalError = 0;
	public static MissingError = 1;
	public static StatusError = 2;
	public static LocationError = 3;

	public static formatVerificationErrorMessage(errorIndex: number, sessionName: string, customerName: string): string {
		switch (errorIndex) {
			case PKBillReaderResultErrorMessage.MissingError:
				return `No bill reader results found for ${sessionName} - ${customerName}`;
			case PKBillReaderResultErrorMessage.StatusError:
				return `Cannot verify ${sessionName} - ${customerName} because one or more bills have an error status`;
			case PKBillReaderResultErrorMessage.LocationError:
				return `No matching location for ${sessionName} - ${customerName}, please correct the customerName/accountNumber/address`;
			default:
				return `Cannot verify ${sessionName} - ${customerName}`;
		}
	}
}

export class PKBillReaderResultLocations {
	public id: number;
	public contractLocationId: string;
	public accountNumber: string;
	public address1: string;

	constructor(data?: PKBillReaderResultLocations) {
		Object.assign(this, data);
	}
}

export class PKBillReaderResults {
	public id: number;
	public sessionId: string;
	public customerName: string;
	public billReaderResultStatusId: number;
	public isVerified: boolean;
	public fileKey: string;
	public agentId?: string;
	public agentName?: string;
	public billReaderResultLocations: PKBillReaderResultLocations[];

	constructor(data?: PKBillReaderResults) {
		Object.assign(this, data);
		if (data?.billReaderResultLocations) {
			this.billReaderResultLocations = data.billReaderResultLocations.map(l => new PKBillReaderResultLocations(l));
		}
	}
}
